import {
  http,
  delay,
  HttpResponse,
} from 'msw';

import { createMockEndpoint } from '@/mocks/create-mock-endpoint';
import { AccountDetailResponse } from '@/repositories/generated';

const responseMock: AccountDetailResponse = {
  id: '1-1',
  name: '山田太郎',
  role: 'SYSTEM_MANAGER',
  status: 'AVAILABLE',
  lockStatus: 'AVAILABLE',
  changedPasswordAt: '2022-12-24T13:10:00+09:00',
  lockedNologinAt: '2023-02-21T13:10:00+09:00',
  loginId: 'test_admin',
  email: 'test_admin@example.com',
  remarks: 'テキストテキストテキストテキストテキストテキスト',
  createdBy: '10',
  createdByName: '佐藤次郎',
  createdAt: '2021-09-24T18:51:00+09:00',
  acquirerId: '1',
  acquirerName: 'テストアクワイアラ1',
  companyId: '0001',
  companyName: 'テスト企業1',
  shopId: '1234',
  shopName: 'テスト店舗 麹町店',
  issuerId: '',
  issuerName: '',
  walletServiceId: '001',
  walletServiceName: '○○Pay',
  updatedAt: '2023-12-20T18:51:00+09:00',
};

const responses: AccountDetailResponse[] = [
  responseMock,
  {
    ...responseMock,
    id: '2-0',
    changedPasswordAt: undefined,
    createdBy: undefined,
    createdByName: undefined,
    lockedNologinAt: undefined,
  },
];

export const accountDetail = http.get(
  createMockEndpoint('/account/:id([^\\(download\\)]+)'), // account/downloadとの競合を避ける
  async ({ params }) => {
    await delay(500);
    return HttpResponse.json(responses.find((response) => response.id === params.id) ?? responseMock, { status: 200 });
  },
);
